import script from "./VWidgetHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./VWidgetHeader.vue?vue&type=script&setup=true&lang=ts"

import "./VWidgetHeader.vue?vue&type=style&index=0&id=24ff94ac&lang=scss"

const __exports__ = script;

export default __exports__